import State from '@/classes/state';
import productFilterAppData from '@/utility/product-filter-app-data';

if (!productFilterAppData) {
    throw new TypeError("Product filter app variable is not available");
}

const { config, translations, productsShop: ps, productsRental: pr } = productFilterAppData;

if (!config) {
    throw new TypeError("Config object is not available");
}

if (!translations) {
    throw new TypeError("Translation object is not available");
}

const productsShop = removeDuplicatesProducts(ps, 'matNo')
const productsRental = removeDuplicatesProducts(pr, 'matNo')

function removeDuplicatesProducts(arr: any[], prop: string) {
    return arr.filter((obj, index, array) => {
        return array.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === index;
    });
}

// Create state
const state = new State({
    config,
    translations,
    products: productFilterAppData.products,
    productsShop,
    productsRental,
    filters: productFilterAppData.filters,
    predefinedFilterItems: productFilterAppData.predefinedFilterItems,
    productSorting: config.initialSorting,
    productLimit: config.initialChunkSize || config.chunkSize,
});

export default state;
